/**
 * @description Initialize the attachment finder with the passed JSON data
 * @param {string} jsonData - The JSON string passed from Liquid
 */
function initializeAttachmentFinder(jsonData) {
    try {
        // Parse the JSON string into an object/array
        const data = JSON.parse(jsonData);
        
        // Ensure data is an array
        if (!Array.isArray(data)) {
            throw new Error("Invalid data format: Expected an array");
        }

        // Get references to the DOM elements
        const machineTypeSelect = document.getElementById('machineType');
        const mountStyleSelect = document.getElementById('mountStyle');
        const attachmentStyleSelect = document.getElementById('attachmentStyle');
        const errorMsg = document.getElementById('errorMessage');
        const findBtn = document.getElementById('goToUrlButton');
        const clearBtn = document.getElementById('clearButton');

        /**
         * @description Populate the Machine Types dropdown
         */
        function populateMachineTypes() {
            machineTypeSelect.innerHTML = '<option value="" selected disabled> Select Machine Type </option>';
            
            data.forEach(machine => {
                const option = document.createElement('option');
                option.value = machine.machineType;
                option.textContent = machine.machineType;
                machineTypeSelect.appendChild(option);
            });

            resetMountAndAttachment();
        }

        /**
         * @description Reset the Mount and Attachment dropdowns
         */
        function resetMountAndAttachment() {
            mountStyleSelect.innerHTML = '<option value="" selected disabled> Select Mount Style </option>';
            mountStyleSelect.disabled = true;
            attachmentStyleSelect.innerHTML = '<option value="" selected disabled> Select Attachment Style </option>';
            attachmentStyleSelect.disabled = true;
            errorMsg.textContent = "";
        }

        /**
         * @description Populate the Mount Styles dropdown
         * @param {Array} mountStyles - List of mount styles for the selected machine
         */
        function populateMountStyles(mountStyles) {
            mountStyleSelect.disabled = false;
            mountStyleSelect.innerHTML = '<option value="" selected disabled> Select Mount Style </option>';

            mountStyles.forEach(ms => {
                const option = document.createElement('option');
                option.value = ms.mountStyle;
                option.textContent = ms.mountStyle;
                mountStyleSelect.appendChild(option);
            });
        }

        /**
         * @description Populate the Attachment Styles dropdown
         * @param {Array} attachmentStyles - List of attachment styles for the selected mount
         */
        function populateAttachmentStyles(attachmentStyles) {
            attachmentStyleSelect.innerHTML = '<option value="" selected disabled> Select Attachment Style </option>';
            
            attachmentStyles.forEach(att => {
                const option = document.createElement('option');
                option.value = att.attachment_name;
                option.textContent = att.attachment_name;
                option.dataset.attachment_url = att.attachment_url;
                attachmentStyleSelect.appendChild(option);
            });

            attachmentStyleSelect.disabled = false;
            findBtn.disabled = false;
        }

        /**
         * Event listener for the Machine Type dropdown change
         */
        machineTypeSelect.addEventListener('change', () => {
            errorMsg.textContent = ""; // Clear any error message

            // Reset Attachment dropdown
            attachmentStyleSelect.innerHTML = '<option value="" selected disabled> Select Attachment Style </option>';
            attachmentStyleSelect.disabled = true;

            const selectedMachine = data.find(m => m.machineType === machineTypeSelect.value);
            if (!selectedMachine) return;
            resetMountAndAttachment();

            if (selectedMachine.mountStyles && selectedMachine.mountStyles.length > 0) {
                populateMountStyles(selectedMachine.mountStyles);
            } else {
                mountStyleSelect.innerHTML = '<option value="" selected disabled> No Mount Style Available </option>';
                mountStyleSelect.disabled = true;
                populateAttachmentStyles(selectedMachine.attachmentStyles);
            }
        });

        /**
         * Event listener for the Mount Style dropdown change
         */
        mountStyleSelect.addEventListener('change', () => {
            errorMsg.textContent = ""; // Clear any error message
            
            // Reset the Attachment dropdown
            attachmentStyleSelect.innerHTML = '<option value="" selected disabled> Select Attachment Style </option>';
            attachmentStyleSelect.disabled = true;

            const selectedMachine = data.find(m => m.machineType === machineTypeSelect.value);
            const selectedMount = selectedMachine.mountStyles.find(ms => ms.mountStyle === mountStyleSelect.value);

            if (selectedMount && selectedMount.attachmentStyles) {
                populateAttachmentStyles(selectedMount.attachmentStyles);
            }
        });

        /**
         * Event listener for the Find button click
         */
        findBtn.addEventListener('click', () => {
            errorMsg.textContent = ""; // Clear any error message
            const selectedOption = attachmentStyleSelect.options[attachmentStyleSelect.selectedIndex];
            
            if (!selectedOption || !selectedOption.value) {
                errorMsg.textContent = "Please select an attachment style";
                return;
            }

            const attachmentUrl = selectedOption.dataset.attachment_url;
            const machineType = machineTypeSelect.value;

            if (!attachmentUrl) {
                errorMsg.textContent = 'URL not configured for this attachment.';
                return;
            }

            const finalUrl = attachmentUrl.includes('?') 
                ? `${attachmentUrl}&utm_source=${encodeURIComponent(machineType)}`
                : `${attachmentUrl}?utm_source=${encodeURIComponent(machineType)}`;

            window.open(finalUrl, '_blank');
        });

        /**
         * Event listener for the Clear button click
         */
        clearBtn.addEventListener('click', () => {
            machineTypeSelect.value = "";
            resetMountAndAttachment();
        });

        // Initialize the dropdowns with machine types
        populateMachineTypes();
    } catch (e) {
        console.error("Invalid JSON format or structure:", e.message);
        alert("There was an error processing the data. Please try again later.");
    }
}
